import { useState } from "react";
import TenantLicenseTable from "./TenentTable";
import { useTenantsUsageTracker } from "@/hooks/useAdminDashboardService";
import { useTenantsCountUsageTracker } from "@/hooks/useAdminDashboardService";
import { useLocation } from "react-router-dom";
import moment from "moment";

interface TenantItem {
  name: string;
  subscriptions?: { licenseCount?: number; endDate?: string; plan?: string }[];
  TenantUsageCounter?: { used?: number }[];
  TenantDataUsageCounter?: { tenant?: number }[];
}

interface IndexProps {
  dashbardView?: boolean;
}

const Index = ({ dashbardView = false }: IndexProps) => {
  const location = useLocation();
  const [filter, setFilter] = useState<"yearly" | "monthly" | "custom">(
    "yearly",
  );
  const [customFrom, setCustomFrom] = useState<string>(
    moment().subtract(1, "day").format("YYYY-MM-DD"),
  );
  const [customTo, setCustomTo] = useState<string>(
    moment().format("YYYY-MM-DD"),
  );

  const [selectedYear, setSelectedYear] = useState<number>(moment().year());
  const [selectedMonth, setSelectedMonth] = useState<number>(
    moment().month() + 1,
  );

  const [tenantFilter, setTenantFilter] = useState<
    "yearly" | "monthly" | "custom"
  >("yearly");
  const [tenantCustomFrom, setTenantCustomFrom] = useState<string>(
    moment().subtract(1, "day").format("YYYY-MM-DD"),
  );
  const [tenantCustomTo, setTenantCustomTo] = useState<string>(
    moment().format("YYYY-MM-DD"),
  );

  const [tenantSelectedYear, setTenantSelectedYear] = useState<number>(
    moment().year(),
  );
  const [tenantSelectedMonth, setTenantSelectedMonth] = useState<number>(
    moment().month() + 1,
  );

  const tenantObjectType = (() => {
    if (tenantFilter === "custom") {
      return {
        type: "custom",
        fromDate: tenantCustomFrom,
        toDate: tenantCustomTo,
      };
    }
    if (tenantFilter === "monthly") {
      return {
        type: "monthly",
        year: tenantSelectedYear,
        month: tenantSelectedMonth,
      };
    }
    return {
      type: "yearly",
      year: tenantSelectedYear,
    };
  })();

  const objectType = (() => {
    if (filter === "custom") {
      return {
        type: "custom",
        fromDate: customFrom,
        toDate: customTo,
      };
    }
    if (filter === "monthly") {
      return {
        type: "monthly",
        year: selectedYear,
        month: selectedMonth,
      };
    }
    return {
      type: "yearly",
      year: selectedYear,
    };
  })();

  const { data: tenantUsageData, isError: isUsageError } =
    useTenantsUsageTracker(objectType);

  const { data: tenantDataUsageData, isError: isTenentUsageError } =
    useTenantsCountUsageTracker(tenantObjectType);

  const tenantsUsedItems: TenantItem[] =
    !isUsageError && Array.isArray(tenantUsageData) ? tenantUsageData : [];

  const tenantsDataUsedItems: TenantItem[] =
    !isTenentUsageError && Array.isArray(tenantDataUsageData)
      ? tenantDataUsageData
      : [];

  const tenantsUsedDataItems = tenantsUsedItems.map((item) => ({
    ...item,
    used: item.TenantUsageCounter?.[0]?.used ?? 0,
    tenant: item.TenantDataUsageCounter?.[0]?.tenant ?? 0,
  }));

  const tenantsDataUsedDataItems = tenantsDataUsedItems.map((item) => ({
    ...item,
    used: item.TenantUsageCounter?.[0]?.used ?? 0,
    tenant: item.TenantDataUsageCounter?.[0]?.tenant ?? 0,
  }));

  return (
    <div className={dashbardView ? "" : "mt-20 p-4"}>
      <TenantLicenseTable
        data={tenantsUsedDataItems}
        filter={filter}
        customFrom={customFrom}
        customTo={customTo}
        setFilter={setFilter}
        setCustomFrom={setCustomFrom}
        setCustomTo={setCustomTo}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedMonth={selectedMonth}
        setSelectedMonth={setSelectedMonth}
      />
      <br />
      <br />

      {location?.pathname === "/usage-tracker" && (
        <>
          <TenantLicenseTable
            data={tenantsDataUsedDataItems}
            filter={tenantFilter}
            customFrom={tenantCustomFrom}
            customTo={tenantCustomTo}
            setFilter={setTenantFilter}
            setCustomFrom={setTenantCustomFrom}
            setCustomTo={setTenantCustomTo}
            selectedYear={tenantSelectedYear}
            setSelectedYear={setTenantSelectedYear}
            selectedMonth={tenantSelectedMonth}
            setSelectedMonth={setTenantSelectedMonth}
            isTenant={true}
          />
        </>
      )}
    </div>
  );
};

export default Index;
